//pages
import Index from '@/views/pages/administration/Index.vue'
import Store from '@/views/pages/administration/store/Store.vue'
import CostCenter from '@/views/pages/administration/costCenter/Index.vue'
import AuditLog from '@/views/pages/administration/audit/Index.vue'
import layouts from '@/layout'
import { isAuditUser } from '@/utils/auth'

export default {
  path: 'administration',
  name: 'Administración',
  component: Index,
  redirect: {
    path: '/store',
    name: 'store'
  },
  icon: 'progress-wrench',
  auth: true,
  meta: {
    nav: true,
    roles: ['admin']
  },
  children: [
     {
       path: '/cost-center',
       name: 'Centro de Costos',
       component: CostCenter,
       meta: {
         nav: true,
         layout: layouts.navLeft,
         roles: ['admin'],
         icon: 'flag-triangle',
        }
     },
    {
      path: '/store',
      name: 'Bodegas',
      component: Store,
      meta: {
        nav: true,
        layout: layouts.navLeft,
        roles: ['admin'],
        icon: 'store',
      }
    },
    {
      path: '/audit-log',
      name: 'Auditoría del Sistema',
      component: AuditLog,
      beforeEnter: (to, from, next) => {
        if (isAuditUser()) {
          next()
        } else {
          next('/') // Redirigir al inicio si no tiene acceso
        }
      },
      meta: {
        nav: isAuditUser(), // Solo mostrar en el menú si el usuario tiene acceso
        layout: layouts.navLeft,
        roles: ['admin'],
        icon: 'file-document-multiple-outline',
      }
    },
    // {
    //   path: '/type_document',
    //   name: 'Tipo Documento',
    //   component: TypeDocument,
    //   meta: {
    //     nav: true,
    //     layout: layouts.navLeft,
    //     roles: ['admin'],
    //     icon: 'account-card-details-outline',
    //   }
    // },
    // {
    //   path: '/referrals',
    //   name: 'Remisiones',
    //   component: Referrals,
    //   meta: {
    //     nav: true,
    //     layout: layouts.navLeft,
    //     roles: ['admin'],
    //     icon: 'swap-horizontal',
    //   }
    // }
  ]
}